var baseAssignValue = require("./_baseAssignValue"), baseForOwn = require("./_baseForOwn"), baseIteratee = require("./_baseIteratee");
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);
  baseForOwn(object, function(value, key, object2) {
    baseAssignValue(result, key, iteratee(value, key, object2));
  });
  return result;
}
module.exports = mapValues;
